module.exports = __webpack_public_path__ + "media/images/dogs/emergency-vets-usa-search-for-local-emergency-vets-and-animal-hospitals-near-you.jpg";